module.exports = __webpack_public_path__ + "static/first_choice_check_details-5afa6ef26014afd531d5f199e167c350.jpg";